'use strict'

import getProjectBrief from './getProjectBrief.js';

export default function getProjectInitiationDocument(project) {
  var version=project.pid!==undefined && project.pid.history!==undefined
    ? project.pid.history.filter(item=>
      project.currentStage!==undefined && item.stage===project.currentStage.id
      || project.currentState===undefined
        && (item.stage===undefined || item.stage===null)).length
    : 0;
  if (project.approvedStages===undefined && version===0) {
    version=1;
  }
  return Object.assign({},getProjectBrief(project),{
    qualityManagementApproach: project.qualityApproach,
    riskManagementApproach: project.riskApproach,
    changeControlApproach: project.changeControlApproach,
    communicationManagementApproach: Object.assign({},project.communicationApproach,{stakeholderCommunication: project.stakeholderCommunication}),
    plan: project.stages,
    projectControls: project.projectControls,
    stage: project.currentStage!==undefined ? project.currentStage.id : undefined,
    version: project.pid!==undefined && project.pid.history!==undefined ? project.pid.history.length : 0,
    minorVersion: version,
    majorVersion: project.approvedStages!==undefined ? project.approvedStages : 0
  });
}



// WEBPACK FOOTER //
// ./app/model/getProjectInitiationDocument.js